import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-directions-popover',
  templateUrl: './directions-popover.component.html',
  styleUrls: ['./directions-popover.component.scss']
})
export class DirectionsPopoverComponent implements OnInit {
  isOpen: boolean = false;

  type: string;
  description: string;

  constructor() {}

  ngOnInit() {}

  open({ type, description }) {
    this.isOpen = true;
    this.type = type;
    this.description = description;
  }

  close() {
    this.isOpen = false;
  }
}
